export default "__VITE_ASSET__Dtb2wxYD__"